module.exports = __webpack_public_path__ + "static/media/close.e5f79e8a.svg";